import { borderRadius, colorGray } from '@atlas-frontend/design-tokens';
import { FC, HTMLAttributes, PropsWithChildren } from 'react';
import styled from 'styled-components';

export type CodeBlockProps = PropsWithChildren & HTMLAttributes<HTMLPreElement>;

export const CodeBlock: FC<CodeBlockProps> = ({ children, ...preProps }) => (
  <Pre {...preProps}>
    <code>{children}</code>
  </Pre>
);

const Pre = styled.pre`
  width: 100%;
  overflow: auto;
  max-height: 300px;
  padding: 1em;
  margin: 0;
  background: #fafafa;
  border: 1px solid ${colorGray[2]};
  border-radius: ${borderRadius}px;
  resize: block;

  // ignore max-height if height property is set via style attribute on the element (effect of manual resize)
  &[style*='height'] {
    max-height: unset;
  }
`;
